<template>
  <div class="card">
    <div class="card-wrap">
      <div class="main">
        <img-lazy class="thumbnail" :src="card.thumbnail | thumbnail(160, 160)"/>
        <div class="content">
          <h2 class="title line-clamp-1">{{ card.name }}</h2>
          <p class="price">￥{{ card.price }}</p>
          <p class="link" @click="onBuy">商品链接  <van-icon name="share" style="vertical-align: text-top;" /></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'
  import { Icon } from 'vant'

  export default {
    name: "card-product",
    components: {ImgLazy, [Icon.name]:Icon},
    props: {
      card: {
        type: Object,
        required: true,
        // default: () => {
        //   return {
        //     name: '这是珠宝',
        //     thumbnail: '',
        //     price: 123424
        //   }
        // }
      }
    },
    methods:{
      onBuy(){
        window.location.href = this.card.url
      }
    }
  }
</script>

<style lang="less" scoped>
  .card {
    padding: 0 20px;
  }

  .card-wrap {
    padding: 20px 0;
  }

  .main {
    display: flex;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    font-size: 20px;
    line-height: 1.6em;
    color: #2d2d2d;
    max-height: 1.6em;
  }

  .price {
    font-size: 14px;
    line-height: 1.6em;
    color: #d7b563;
    flex: 1;
    vertical-align: top;
  }

  .link {
    font-size: 12px;
    line-height: 1.6em;
    color: #b4b4b4;
  }

  .thumbnail {
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
</style>